import { render, staticRenderFns } from "./EducationalCategoryStorageSpaceComponent.vue?vue&type=template&id=4674ee8c&"
import script from "./EducationalCategoryStorageSpaceComponent.vue?vue&type=script&lang=js&"
export * from "./EducationalCategoryStorageSpaceComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports